import { FC, useCallback } from 'react';

import { Button, Group, Paper, PasswordInput, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';

import useLogin from '@/hooks/useLogin.tsx';

import { AutorizationData } from '@/types/authorization';

type Props = {
	onBack?: () => void;
};

export const LoginForm: FC<Props> = ({ onBack }) => {
	const form = useForm({
		initialValues: {
			username: '',
			password: '',
			remember: true,
			directory_id: 2,
		},
		transformValues: (values) => ({
			...values,
			username: values.username.trim(),
			password: values.password.trim(),
		}),
	});

	const { login, isLoading } = useLogin();

	const handleLogin = useCallback(
		async (data: AutorizationData) => {
			try {
				await login(data);
			} catch (error) {
				notifications.show({
					color: 'red',
					message: error as string,
				});
			}
		},
		[login],
	);

	return (
		<form onSubmit={form.onSubmit((values) => handleLogin(values))} style={{ width: 400 }}>
			<Paper withBorder shadow="md" p={30} radius="md">
				<TextInput
					radius="md"
					mt="sm"
					placeholder="Логин"
					required
					{...form.getInputProps('username')}
				/>
				<PasswordInput
					radius="md"
					mt="sm"
					placeholder="Пароль"
					id="password"
					required
					{...form.getInputProps('password')}
				/>
				<Group justify="center" mt="sm">
					<Button type="submit" loading={isLoading}>
						Войти
					</Button>
					{onBack && (
						<Button type="button" variant="subtle" onClick={onBack}>
							← Назад
						</Button>
					)}
				</Group>
			</Paper>
		</form>
	);
};
